import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { AccountBalanceDataRepository } from "../domain/AccountBalanceDataRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { AccountBalanceFull } from "../domain/AccountBalanceFull";

export function createApiAccountBalanceDataRepository(): AccountBalanceDataRepository {
  return new APIAccountBalanceDataRepository();
}

export class APIAccountBalanceDataRepository
  extends APIRepository
  implements AccountBalanceDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getAccountBalanceFull(companyUid: string): Promise<AccountBalanceFull[]> {
    console.log("getAccountBalanceFull companyUid: " + companyUid);
    return this.doGet<AccountBalanceFull[]>("/api/accountbalancesdata/company/" + companyUid.toString());
  }
}